import React from "react";

import { Icon } from "../../atoms/Icon";
import Image from "../../atoms/Image/Image";
import styles from "./ImageGridItem.module.scss";

function ImageGridItem({ src, onSubtractItem, index }) {
  return (
    <div className={styles.imageListItem} key={index}>
      <Image src={src} />
      <div
        className={styles.iconPositionWrapper}
        onClick={() => onSubtractItem(index)}
      >
        <Icon
          name="Declined"
          size={21}
          color="#9fa9ba"
          className={styles.icon}
        />
      </div>
    </div>
  );
}

export default ImageGridItem;
